import './index.scss';

import React, { useMemo, useState } from 'react';
import { getLocale, useIntl } from 'umi';

import { Card, Justify, Button, Select, Row, Col, Bubble } from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { ICardConfig, ICardContentProp, TMetric } from '../../type';
import NoData from '@intelligence/components/NoData';

export default function MetricCardContext(props: { data?: ICardContentProp[] }) {
  const { data } = props;

  return Array.isArray(data) && data.length > 0 ? (
    <>
      {data.map((item: ICardContentProp, idx: number) => {
        return (
          <div
            key={`card-${idx}`}
            className={`dbi-marketprofile-cardcontext ${item?.compareText} ? 'cardcontext-cursor' : ''}`}
          >
            <div className="cardcontext-cont">
              <div className="cardcontext-title">
                {item?.label || '-'}
                {item?.compareText ? <TipContext tipText={item?.compareText} /> : ''}
              </div>
              <div className="cardcontext-num">{item?.value || '-'}</div>
              <div className="cardcontext-info">
                {/* <div className="cardcontext-text">{item?.compareText}:</div> */}
                <Bubble dark content={item?.compareText} placement="bottom-start">
                  <div className={item?.isUp ? 'cardcontext-green' : 'cardcontext-red'}>
                    <span>{item?.growth || '-'}</span>
                    <SvgIcon
                      type={item?.isUp ? 'green-up-new' : 'red-down-new'}
                      className="cardcontext-icon"
                    />
                  </div>
                </Bubble>
              </div>
            </div>
          </div>
        );
      })}
    </>
  ) : (
    <NoData />
  );
}
